import moment from 'moment';

export const formatDate = (dateString: Date | undefined) => {
  return moment(dateString).format('MMM DD, YYYY');
};
